import { useState } from 'react';
import '../Admin.scss';
import {
  CHURCH_RECRUIT_CONFIG,
  INSTITUTE_RECRUIT_CONFIG,
} from '../../screens/recruit/common/recruitConfigs';
import RegisterRecruitMinister from './RegisterRecruitMinister';
import RecruitCategorySavedManage from './RecruitCategorySavedManage';

export type RecruitManageTab = 'minister' | 'overseas' | 'church' | 'institute';

const MANAGE_TABS: { key: RecruitManageTab; label: string }[] = [
  { key: 'minister', label: '국내사역지' },
  { key: 'overseas', label: '해외사역지' },
  { key: 'church', label: '찬양대/방송/직원' },
  { key: 'institute', label: '학교/기관/단체' },
];

export default function RecruitSavedManage() {
  const [activeTab, setActiveTab] = useState<RecruitManageTab>('minister');

  return (
    <div className="admin-board-write recruit-saved-manage">
      <div className="admin-board-write__tabs" role="tablist" aria-label="구인구직 관리 선택">
        {MANAGE_TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.key}
            className={`admin-board-write__tab${activeTab === tab.key ? ' is-active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="admin-board-write__panel" role="tabpanel">
        {activeTab === 'minister' && <RegisterRecruitMinister key="minister" />}
        {activeTab === 'overseas' && <RegisterRecruitMinister key="overseas" overseas />}
        {activeTab === 'church' && (
          <RecruitCategorySavedManage config={CHURCH_RECRUIT_CONFIG} manageTitle="찬양대/방송/직원" />
        )}
        {activeTab === 'institute' && (
          <RecruitCategorySavedManage config={INSTITUTE_RECRUIT_CONFIG} manageTitle="학교/기관/단체" />
        )}
      </div>
    </div>
  );
}
